export default "__VITE_ASSET__DOEdioV6__"